import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import axiosInstance from "../../axiosInterceptor";
import { useFormik } from "formik";
import CodeEditor from "../../Components/CodeEditor";
import ImageUploadDragAndDrop from "../../Components/ImageUploadDragAndDrop";

const WebSetting = () => {
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      companyName: "",
      address: "",
      description: "",
      email: "",
      email2: "",
      contactNo: "",
      whatsAppNo: "",
      mapUrl: "",
      headerLogo: null,
      headerTransparentLogo: null,
      footerLogo: null,
      businessHours: "",
      brochureFile: ""
    },

    onSubmit: async (values) => {
      setLoading(true);
      try {
        const formData = new FormData();
        Object.entries(values).forEach(([key, value]) => {
          if (
            value !== null &&
            value !== "" &&
            key !== "_id" &&
            key !== "createdAt" &&
            key !== "updatedAt" &&
            key !== "__v"
          ) {
            if (key === "headerLogo" || key === "footerLogo" || key === "headerTransparentLogo" || key === "brochureFile") {
              if (value instanceof File) {
                formData.append(key, value);
              }
            } else {
              formData.append(key, value);
            }
          }
        });

        await axiosInstance.post("websetting/createwebsetting", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        toast.success("Website settings updated successfully");
      } catch (err) {
        toast.error(err?.response?.data?.message || "Update failed");
      } finally {
        setLoading(false);
      }
    },
  });

  const {
    values,
    handleChange,
    handleBlur,
    handleSubmit,
    setFieldValue,
    errors,
    touched,
    setValues,
    initialValues,
  } = formik;
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosInstance.get("websetting/getwebsetting");

        if (response?.data?.data) {
          const { _id, createdAt, updatedAt, ...safeData } = response.data.data;

          setValues({
            ...initialValues,
            ...safeData,
            headerLogo: safeData.headerLogo || null,
            footerLogo: safeData.footerLogo || null,
            brochureFile: safeData.brochureFile || null,
            headerTransparentLogo: safeData.headerTransparentLogo || null,
          });
        }
      } catch (error) {
        toast.error("Failed to fetch configuration");
      }
    };

    fetchData();
  }, [setValues, initialValues]);

  return (
    <div className="content-wrapper">
      <div className="page-header">
        <h3 className="page-title">Website Settings</h3>
      </div>

      <div className="card">
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="row mb-4">
              <div className="col-md-4 mb-3">
                <label
                  className="form-label fw-semibold "
                  htmlFor="companyName"
                >
                  Company Name
                </label>
                <input
                  type="text"
                  id="companyName"
                  name="companyName"
                  className="form-control border border-dark"
                  value={values.companyName}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Enter Company Name"
                />
              </div>
              <div className="col-md-4">
                <label
                  className="form-label fw-semibold "
                  htmlFor="businessHours"
                >
                  Business Hours
                </label>
                <input
                  type="text"
                  id="businessHours"
                  name="businessHours"
                  className="form-control border border-dark"
                  value={values.businessHours}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Enter business hours"
                />
              </div>

              <div className="col-md-4 mb-3">
                <label className="form-label fw-semibold" htmlFor="email">
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  className="form-control border border-dark"
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Enter Email"
                />
              </div>

              <div className="col-md-4 mb-3">
                <label className="form-label fw-semibold" htmlFor="email2">
                  Email2
                </label>
                <input
                  type="email2"
                  id="email2"
                  name="email2"
                  className="form-control border border-dark"
                  value={values.email2}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Enter Email2"
                />
              </div>

              <div className="col-md-4 mb-2">
                <label className="form-label fw-semibold" htmlFor="whatsAppNo">
                  Whatsapp No
                </label>
                <input
                  type="text"
                  id="whatsAppNo"
                  name="whatsAppNo"
                  className="form-control border border-dark"
                  value={values.whatsAppNo}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Enter Whatsapp No"
                />
              </div>

              <div className="col-md-4 mb-2">
                <label className="form-label fw-semibold">Contact No</label>
                <input
                  type="text"
                  id="contactNo"
                  name="contactNo"
                  className="form-control border border-dark"
                  value={values.contactNo}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Enter Contact No"
                />
              </div>
              <div className="col-md-4 mb-2">
                <label className="form-label fw-semibold">Description</label>
                <CodeEditor
                  placeholder={"Enter Description"}
                  value={values.description}
                  onChange={(val) => setFieldValue("description", val)}
                  className="form-control border border-dark"
                />
              </div>
              <div className="col-md-4 mb-2">
                <label className="form-label fw-semibold">Address</label>
                <CodeEditor
                  placeholder={"Enter Address"}
                  value={values.address}
                  onChange={(val) => setFieldValue("address", val)}
                  className="form-control border border-dark"
                />
              </div>

              <div className="col-md-4 mb-2">
                <label className="form-label fw-semibold" htmlFor="mapUrl">
                  Contact Map URL
                </label>
                <textarea
                  name="mapUrl"
                  id="mapUrl"
                  rows={13}
                  className="form-control border border-dark"
                  value={values.mapUrl}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Enter Contact Map URL"
                />
              </div>

              <div className="col-md-4">
                <ImageUploadDragAndDrop
                  id="website-setting-headerLogo"
                  label={`Header Logo`}
                  value={values.headerLogo}
                  onChange={(file) => setFieldValue("headerLogo", file)}
                  error={errors.headerLogo}
                  touched={touched.headerLogo}
                />
              </div>

              <div className="col-md-4">
                <ImageUploadDragAndDrop
                  id="website-setting-headerLogo"
                  label={`Header Transparent Logo`}
                  value={values.headerTransparentLogo}
                  onChange={(file) => setFieldValue("headerTransparentLogo", file)}
                  error={errors.headerTransparentLogo}
                  touched={touched.headerTransparentLogo}
                />
              </div>

              <div className="col-md-4">
                <ImageUploadDragAndDrop
                  id="website-setting-footerLogo"
                  label={`Footer Logo`}
                  value={values.footerLogo}
                  onChange={(file) => setFieldValue("footerLogo", file)}
                  error={errors.footerLogo}
                  touched={touched.footerLogo}
                />
              </div>

              <div className="col-md-4">
                <ImageUploadDragAndDrop
                  id="website-setting-headerLogo"
                  label="Footer Brochure File"
                  value={values.brochureFile}
                  onChange={(file) => setFieldValue("brochureFile", file)}
                  error={errors.brochureFile}
                  touched={touched.brochureFile}
                  accept=".pdf"
                />
              </div>
            </div>

            <div className="text-center mt-4">
              <button
                type="submit"
                className="btn btn-primary px-4"
                disabled={loading}
              >
                {loading ? "Saving..." : "Update Settings"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default WebSetting;
